import React, { Component } from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";

export default class ListHeader extends Component {
  render() {
    return (
      <div
        className={
          this.props.dark
            ? "card-header d-flex justify-content-between align-items-center grey"
            : "card-header d-flex justify-content-between align-items-center"
        }
      >
        {this.props.dark ? <h5 className="m-0">{Title(this.props)}</h5> : <span>{Title(this.props)}</span>}
        {this.props.showAction && (
          <div>
            <NavLink to={this.props.actionLink} className="btn btn-primary m-0">
              <i className="fa fa-plus"></i>
            </NavLink>
          </div>
        )}
        {this.props.buttons && (
          <div className="d-flex justify-content-center align-items-center">
            {this.props.buttons.map((button) => {
              return (
                <div>
                  {button.actionLink ? (
                    <NavLink to={button.actionLink} disabled={button.disabled} className={button.buttonClass}>
                      {button.buttonTitle}
                    </NavLink>
                  ) : (
                    <span className={button.buttonClass} onClick={button.buttonAction}>
                      {button.buttonTitle}
                    </span>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>
    );
  }
}

const Title = (props) => {
  return (
    <div>
      <i className={props.iconClass}></i>
      {props.title}
    </div>
  );
};

ListHeader.propTypes = {
  showAction: PropTypes.bool,
  iconClass: PropTypes.string,
  title: PropTypes.string,
  actionLink: PropTypes.string,
  dark: PropTypes.bool,
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      buttonTitle: PropTypes.string.isRequired,
      buttonAction: PropTypes.func,
      actionLink: PropTypes.string,
      buttonClass: PropTypes.string.isRequired,
      disabled: PropTypes.bool,
    })
  ),
};

ListHeader.defaultProps = {
  showAction: true,
};
